export function isValidPhoneNumber(number){
  if(number != undefined) {
    var phoneNumber = /^[0-9]{7}$/;
    if (number.startsWith("+") || number.startsWith("00")) {
      phoneNumber = /^(\+|00)[0-9]{7,}$$/;
    }
    else if (number.startsWith("3")) {
      phoneNumber = /^[0-9]{9}$/;
    }
    var phone = number.match(phoneNumber);
    return phone != null;
  }
  return false;
}

export function isInvalidPhoneNumber(number){
  if(number != undefined) {
    var phoneNumber = /^[0-9]{7}$/;
    if (number.startsWith("+") || number.startsWith("00")) {
      phoneNumber = /^(\+|00)[0-9]{7,}$$/;
    }
    else if (number.startsWith("3")) {
      phoneNumber = /^[0-9]{9}$/;
    }
    var phone = number.match(phoneNumber);
    return phone == null;
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/phoneNumberUtils.js